export const PRODUCT_DETAILS_JOURNEY_ID = 'online-shop/product-details';

// product details journey contentKeys
export const UPFRONT_ONLY_ERROR_CONTENT_KEY =
  'productDetails.ifpEligibility.upfrontOnlyError';
export const MESSAGE_ME_ONLINE_CONTENT_KEY =
  'productDetails.ifpEligibility.messageMeOnline';
export const UPFRONT_PAYMENT_REQUIRED_CONTENT_KEY =
  'productDetails.paymentOptions.upfrontPayment.required';
export const UPFRONT_PAYMENT_NOT_REQUIRED_CONTENT_KEY =
  'productDetails.paymentOptions.upfrontPayment.notRequired';
